export const InizioProcesso = 'INIZIO_PROCESSO'
export const Bozza = 'BOZZA'
export const NotificaBozza = 'NOTIFICA_BOZZA'
export const DaFirmare = 'DA_FIRMARE'
export const Firmata = 'FIRMATA'
export const Annullata = 'ANNULLATA'